angular.module('display').config([
        'AppRoutesProvider',
        '$stateProvider',
        function config(
            AppRoutesProvider,
            $stateProvider
            ) {
            'use strict';

            var appRoutes = {
                'display':{
                    state: 'display',
                    route: '/display/{patientSearchResult:json}',
                    portalSettings: {
                        hideHeader: false
                    }
                }
            };

            AppRoutesProvider.setupAppRoutes(appRoutes);

            $stateProvider
                .state(appRoutes.display.state, {
                    url: appRoutes.display.route,
                    component: 'display'
                });
        }]);
